import React, { useState } from "react"
import { Row, Card, Button, Alert } from "react-bootstrap"
import { useAuth } from "../contexts/AuthContext"
import { Link, useNavigate } from "react-router-dom"
import RegistrationChart from "./dashboard/chart_registration"
import TripsChart from "./dashboard/chart_trips"
import TicketsChart from "./dashboard/chart_tickets"
import MileageChart from "./dashboard/chart_mileage"


export default function Dashboard() {
  const [error, setError] = useState("")
  const { currentUser, logout } = useAuth()
  const navigate = useNavigate()

  async function handleLogout() {
    setError("")

    try {
      await logout()
      navigate("/login")
    } catch {
      setError("Failed to log out")
    }
  }

  return (
    <>
    <Row xs={1} md={2} className="g-4">
      <Card md={6}>
        <Card.Body>
          <RegistrationChart />
        </Card.Body>
      </Card>
      <Card md={6}>
        <Card.Body>
          <TicketsChart />
        </Card.Body>
      </Card>
      <Card md={6}>
        <Card.Body>
          <MileageChart />
        </Card.Body>
      </Card>
      <Card md={6}>
        <Card.Body>
          <TripsChart />
        </Card.Body>
      </Card>
      </Row>
    </>
  )
}